import type { Plurals, Strings } from '../index';

export const strings: Strings = {
  'menu.home': 'Domov',
  'menu.notes': 'Zapiski',
  'menu.reminders': 'Opomniki',
  'menu.passwords': 'Gesla',
  'menu.cards': 'Kartice',
  'menu.photoIds': 'Osebni dokumenti',
  'menu.collections': 'Zbirke',
  'menu.conflicts': 'Neskladja ({count})',
  'menu.settings': 'Nastavitve',
  'menu.lock': 'Zakleni denarnico',
  'menu.language': 'Jezik',

  'type.note': 'Zapisek',
  'type.note.plural': 'Zapiski',
  'type.password': 'Geslo',
  'type.password.plural': 'Gesla',
  'type.card': 'Kartica',
  'type.card.plural': 'Kartice',
  'type.photoId': 'Osebni dokument',
  'type.photoId.plural': 'Osebni dokumenti',

  'section.upcoming': 'Prihajajoči opomniki',
  'section.pinned': 'Pripeto',
  'section.recent': 'Nedavno',
  'section.searchResults': 'Rezultati iskanja',
  'section.conflicts': 'Neskladja',

  'action.addNew': '+ Dodaj',
  'action.back': 'Nazaj',
  'search.placeholder': 'Poiščite ali dodajte novo',

  'gate.title': 'Vse pomembno',
  'gate.copy': 'Vaša denarnica je šifrirana na tej napravi, preden se kar koli sinhronizira.',
  'gate.create': 'Ustvari novo denarnico',
  'gate.open': 'Odpri obstoječo denarnico',
  'gate.recover': 'Obnovi dostop do denarnice',

  'empty.addFirst': 'Dodajte svoj prvi vnos.',
  'empty.nothingHere': 'Tukaj še ni ničesar.',
  'empty.noResults': 'Noben shranjen vnos ne ustreza iskanju.',

  'action.cancel': 'Prekliči',
  'action.save': 'Shrani',
  'action.saving': 'Shranjevanje…',
  'action.close': 'Zapri',
  'action.edit': 'Uredi',
  'action.delete': 'Izbriši',
  'action.remove': 'Odstrani',
  'action.change': 'Spremeni',
  'action.clear': 'Počisti',
  'action.add': 'Dodaj',
  'action.show': 'Pokaži',
  'action.hide': 'Skrij',
  'action.more': 'Več',

  'field.title': 'Naslov',
  'field.body': 'Besedilo',
  'field.username': 'Uporabniško ime',
  'field.password': 'Geslo',
  'field.website': 'Spletno mesto',
  'field.notes': 'Zapiski',
  'field.cardNumber': 'Številka kartice',
  'field.documentNumber': 'Številka dokumenta',
  'field.expiry': 'Velja do',
  'field.securityCode': 'Varnostna koda',
  'field.cvv': 'CVV / CVC',
  'field.pin': 'PIN',
  'field.documentType': 'Vrsta dokumenta',
  'field.reminder': 'Opomnik',
  'field.collections': 'Zbirke',
  'field.idPhotos': 'Fotografiji dokumenta',
  'field.attachments': 'Priloge',

  'editor.newItem': 'Nov vnos: {type}',
  'editor.editItem': 'Uredi: {type}',
  'editor.titlePlaceholder': 'Naslov ({type})',
  'editor.selectDocumentType': 'Izberite vrsto dokumenta',
  'editor.noneSelected': 'Nič ni izbrano',
  'editor.optional': 'Neobvezno',
  'editor.optionalFields': 'Neobvezna polja',
  'editor.reminderDate': 'Datum opomnika',
  'editor.optionalTime': 'Ura (neobvezno)',
  'editor.shortcutHint': 'Ctrl+Enter shrani. Esc prekliče.',
  'editor.addTitle': 'Dodajte naslov.',
  'editor.saveFailed': 'Tega vnosa ni bilo mogoče shraniti.',
  'editor.photoFailed': 'Te fotografije ni bilo mogoče pripraviti.',
  'editor.attachmentFailed': 'Te priloge ni bilo mogoče pripraviti.',
  'editor.photoNote': 'Fotografije do {mb} MB so šifrirane in shranjene v tej napravi, nato pa samodejno sinhronizirane, če je sinhronizacija vklopljena.',
  'editor.attachmentNote': 'Datoteke so šifrirane natanko tako, kot so bile izbrane, in shranjene v tej napravi. Safe Wallet blokira običajne izvršljive datoteke, skripte, aktivno spletno vsebino in datoteke z makri, vendar jih ne pregleda za zlonamerno programsko opremo.',
  'editor.attachmentButton': 'Priloga (največ {mb} MB)',
  'editor.addingAttachment': 'Dodajanje priloge…',
  'editor.preparing': 'Pripravljanje…',
  'editor.takePhoto': 'Fotografiraj',
  'editor.choosePhoto': 'Izberi fotografijo',
  'editor.front': 'Sprednja stran',
  'editor.back': 'Zadnja stran',
  'editor.tapAddFront': 'Tapnite za dodajanje sprednje strani',
  'editor.tapAddBack': 'Tapnite za dodajanje zadnje strani',
  'editor.photoNotOnDevice': 'Šifrirana fotografija ni shranjena v tej napravi.',
  'editor.pinItem': 'Pripni',
  'editor.pinned': 'Pripeto',
  'editor.deleteItem': 'Izbriši vnos',

  'viewer.noBody': 'Ni besedila.',
  'viewer.notSet': 'Ni nastavljeno',
  'viewer.escCloses': 'Esc zapre ta pogled.',

  'attach.title': 'Priloga',
  'attach.notOnDevice': 'Šifrirana priloga še ni shranjena v tej napravi.',
  'attach.photoNotOnDevice': 'Šifrirana fotografija še ni shranjena v tej napravi.',
  'attach.openingPhoto': 'Odpiranje šifrirane fotografije…',
  'attach.opening': 'Odpiranje…',
  'attach.notStored': 'Ni shranjeno v tej napravi',
  'attach.couldNotOpen': 'Te priloge ni bilo mogoče odpreti.',
  'attach.previewUnavailable': 'Predogled za to vrsto datoteke ni na voljo. Prenesite jo in odprite z aplikacijo, ki ji zaupate.',
  'attach.previewLimited': 'Predogled je omejen na prvi 1 MB.',
  'attach.openPdf': 'Odpri PDF',
  'attach.download': 'Prenesi',

  'expiry.label': 'Velja do (MM/LL)',
  'expiry.month': 'Mesec veljavnosti',
  'expiry.chooseMonthYear': 'Izberite mesec in leto',
  'expiry.chooseDate': 'Izberite datum veljavnosti',
  'expiry.previousYear': 'Prejšnje leto',
  'expiry.nextYear': 'Naslednje leto',

  'collections.createFirst': 'Najprej ustvarite zbirke v glavnem meniju.',
  'chooser.addNew': 'Dodaj',

  'settings.title': 'Nastavitve',
  'settings.account': 'Račun',
  'settings.security': 'Varnost',
  'settings.recovery': 'Obnovitev',
  'settings.thisDevice': 'Ta naprava',
  'settings.appearance': 'Videz',
  'settings.searchPrivacy': 'Zasebnost iskanja',
  'settings.dangerZone': 'Občutljivo območje',
  'settings.notSignedIn': 'Niste prijavljeni',
  'settings.pinOnly': 'Samo PIN',
  'settings.pinAndFingerprint': 'PIN + prstni odtis',
  'settings.changePinRow': 'Spremenite PIN aplikacije v tej napravi. Potreben je trenutni PIN.',
  'settings.lockNow': 'Zakleni zdaj',
  'settings.chooseAnotherWallet': 'Izberi drugo denarnico',
  'settings.useAnotherAccount': 'Uporabi drug račun',
  'settings.categoryLabels': 'Oznake kategorij',
  'settings.rowSpacing': 'Razmik med vrsticami',
  'settings.textSize': 'Velikost besedila',
  'settings.autoLock': 'Samodejno zaklepanje',
  'settings.optionName': 'Ime',
  'settings.optionIcon': 'Ikona',
  'settings.optionBoth': 'Oboje',
  'settings.optionLarge': 'Veliko',
  'settings.optionMedium': 'Srednje',
  'settings.optionCompact': 'Strnjeno',
  'settings.optionSmall': 'Majhno',
  'settings.searchPrivacyNote': 'Dešifrirano kazalo iskanja obstaja samo v tej odklenjeni napravi in se izbriše, ko se denarnica zaklene. Gesla, koda PIN, številke kartic in računov, varnostne kode, številke dokumentov, obnovitvene kode in podobne skrivnosti niso nikoli indeksirane.',
  'settings.exampleProjection': 'Primer za prvi vnos',
  'settings.noItemsYet': 'Še ni vnosov.',
  'settings.removeWalletNote': 'Odstranitev te denarnice iz tega brskalnika ne izbriše njene šifrirane varnostne kopije v računu.',
  'settings.removeWallet': 'Odstrani to lokalno denarnico',

  'pin.changeTitle': 'Spremeni PIN aplikacije',
  'pin.change': 'Spremeni PIN',
  'pin.changing': 'Spreminjanje…',
  'pin.current': 'Trenutni PIN',
  'pin.new': 'Nov PIN',
  'pin.repeat': 'Ponovite nov PIN',
  'pin.accountPassword': 'Geslo računa',
  'pin.accountPasswordHint': 'Potrebno za posodobitev prijave v vaših drugih napravah.',
  'pin.noteSynced': 'Shranjenih vnosov ni treba znova šifrirati. Ker se ta denarnica sinhronizira, je geslo računa potrebno, da nov PIN deluje tudi ob prijavi v novi napravi.',
  'pin.noteLocal': 'Trenutni PIN odklene to denarnico v tej napravi. Shranjenih vnosov ni treba znova šifrirati.',
  'pin.errCurrent': 'Vnesite trenutni PIN aplikacije s 6 do 12 številkami.',
  'pin.errNew': 'Uporabite nov PIN aplikacije s 6 do 12 številkami.',
  'pin.errMismatch': 'Vnosa novega PIN-a se ne ujemata.',
  'pin.errSame': 'Izberite nov PIN, ki se razlikuje od trenutnega.',
  'pin.errPassword': 'Vnesite geslo svojega računa.',
  'pin.errFailed': 'PIN-a aplikacije ni bilo mogoče spremeniti.',

  'fingerprint.title': 'Odklepanje s prstnim odtisom',
  'fingerprint.settingUp': 'Nastavljanje…',
  'fingerprint.unavailable': 'Ta naprava tega ne zmore.',
  'fingerprint.errOn': 'Tega ni bilo mogoče vklopiti.',
  'fingerprint.errOff': 'Tega ni bilo mogoče izklopiti.',

  'sync.off': 'Izklopljeno — samo v tej napravi',
  'sync.notConfigured': 'Izklopljeno — sinhronizacija ni nastavljena',
  'sync.connecting': 'Povezovanje…',
  'sync.uploading': 'Vklopljeno — sinhroniziranje šifrirane varnostne kopije…',
  'sync.waiting': 'Vklopljeno — šifrirane spremembe čakajo na pošiljanje',
  'sync.connected': 'Vklopljeno — šifrirana varnostna kopija povezana',
  'sync.offline': 'Brez povezave — šifrirana varnostna kopija je začasno ustavljena',

  'account.signedIn': 'Prijavljeni',
  'account.signedInAs': 'Prijavljeni kot',
  'account.anotherAccount': 'Drug račun',
  'account.currentAccount': 'Trenutni račun',
  'account.wallet': 'Denarnica',
  'account.sync': 'Sinhronizacija',
  'account.device': 'Naprava',
  'account.signOut': 'Odjava',
  'account.signOutOf': 'Odjavi se iz računa {account}',
  'account.email': 'E-pošta',
  'account.pinLabel': 'PIN za Safe Wallet',
  'account.pinHint': 'Vaš PIN za to denarnico. Če ima ta račun že denarnico, uporabite PIN tiste denarnice.',
  'account.pinPlaceholder': '6–12 številk',
  'account.signInTab': 'Prijava',
  'account.createTab': 'Ustvari račun',
  'account.forgotPassword': 'Ste pozabili geslo računa?',
  'account.signInSync': 'Prijava in sinhronizacija',
  'account.createSync': 'Ustvari račun in sinhroniziraj',
  'account.signInSyncTitle': 'Prijava in sinhronizacija',
  'account.differentSession': 'V tem brskalniku je prijavljen račun, vendar ta lokalna denarnica ni povezana s tem računom. Spodaj odprite »Prijava in sinhronizacija« in povežite račun, ki mu ta denarnica pripada, ali se najprej odjavite in uporabite drug račun.',
  'account.notConfigured': 'Sinhronizacija za to namestitev ni nastavljena.',
  'account.confirmEmail': 'Potrdite račun prek e-pošte, nato se vrnite in prijavite. Ta lokalna denarnica še ni povezana.',
  'account.errPin': 'Vnesite PIN za Safe Wallet s 6 do 12 številkami za to denarnico.',
  'account.errSession': 'Seje računa ni bilo mogoče vzpostaviti.',
  'account.connected': 'Denarnica je povezana. Sinhronizacija se začenja.',
  'account.connectedNoSync': 'Račun je povezan. Sinhronizacija v tem okolju ni na voljo.',
  'account.errConnect': 'Tega računa ni bilo mogoče povezati.',
  'account.resetSent': 'Preverite e-pošto za povezavo za ponastavitev gesla.',
  'account.errReset': 'E-pošte za ponastavitev ni bilo mogoče poslati.',
  'account.signedOut': 'Odjavljeni iz računa. Šifrirana denarnica ostaja na voljo v tej napravi.',

  'pairing.advanced': 'Napredno: odobri drugo napravo',
  'pairing.advancedNote': 'To uporabite le, kadar običajna prijava z geslom in PIN-om ni mogoča. Pred odobritvijo primerjajte prstni odtis v obeh napravah.',
  'pairing.none': 'Ni naprav na čakanju.',
  'pairing.invalidKey': 'Neveljaven ključ za seznanitev',
  'pairing.calculating': 'Računanje prstnega odtisa…',
  'pairing.review': 'Preveri',
  'pairing.reviewTitle': 'Preveri novo napravo',
  'pairing.fingerprint': 'Prstni odtis za preverjanje',
  'pairing.compare': 'Primerjajte vsako skupino s prstnim odtisom, prikazanim v novi napravi.',
  'pairing.doNotApprove': 'Ob neujemanju ne odobrite.',
  'pairing.mismatchNote': 'To lahko pomeni, da je bil ključ za seznanitev spremenjen in da bi bil ključ denarnice lahko poslan napačni napravi.',
  'pairing.confirm': 'Primerjal sem oba prstna odtisa in se popolnoma ujemata.',
  'pairing.approve': 'Odobri napravo',
  'pairing.approving': 'Odobravanje…',
  'pairing.approved': 'Naprava {device} je odobrena.',
  'pairing.errInvalid': 'Ta zahteva za odobritev vsebuje neveljaven ključ za seznanitev. Zavrnite jo in začnite novo zahtevo.',
  'pairing.errChanged': 'Ključ za seznanitev se je med preverjanjem spremenil. Prekličite to zahtevo.',
  'pairing.errApprove': 'Te naprave ni bilo mogoče odobriti.',

  'wallet.localOnly': 'Samo lokalna denarnica',
  'wallet.lastUsedRecently': 'Nazadnje uporabljeno pred kratkim',
  'wallet.notConnected': 'Ni povezano z računom',
  'wallet.availableOnDevice': 'Denarnica je na voljo v tej napravi',
  'wallet.onlyThisDevice': 'Samo v tej napravi — sinhronizacija je izklopljena',

  'fingerprint.confirmBackup': 'Želite vklopiti odklepanje s prstnim odtisom?\n\nPo tem boste za odpiranje te denarnice v tej napravi potrebovali prstni odtis in PIN. Če prstni odtis kdaj preneha delovati, boste lahko dostop obnovili z varnostno prijavo ali prek zaupanja vrednega stika.',
  'fingerprint.confirmNoBackup': 'Želite vklopiti odklepanje s prstnim odtisom?\n\nPo tem boste za odpiranje te denarnice v tej napravi potrebovali prstni odtis in PIN. Ta denarnica še nima varnostne kopije, zato je ne bo več mogoče odpreti, če prstni odtis preneha delovati. Močno priporočamo, da najprej vklopite sinhronizacijo.',

  'gate.cloudNotConfigured': 'Oblak še ni nastavljen. Zdaj lahko ustvarite lokalno denarnico in jo pozneje povežete v nastavitvah.',

  'create.title': 'Ustvarite PIN aplikacije',
  'create.intro': 'PIN odklene to napravo. Geslo računa bo ločeno, ko vklopite sinhronizacijo.',
  'create.walletName': 'Ime denarnice',
  'create.walletNameHint': 'Prikazano v tem brskalniku pred vnosom PIN-a.',
  'create.walletNamePlaceholder': 'Alex, Sam, Družinski sef…',
  'create.deviceName': 'Ime naprave',
  'create.appPin': 'PIN aplikacije',
  'create.repeatPin': 'Ponovite PIN',
  'create.creating': 'Ustvarjanje…',
  'create.createWallet': 'Ustvari denarnico',
  'create.errPin': 'Uporabite PIN aplikacije s 6 do 12 številkami.',
  'create.errMismatch': 'Vnosa PIN-a se ne ujemata.',
  'create.errFailed': 'Te denarnice ni bilo mogoče ustvariti.',
  'create.errHello': 'Odklepanja s prstnim odtisom ni bilo mogoče vklopiti.',
  'create.fingerprintTitle': 'Želite dodati prstni odtis ali obraz?',
  'create.fingerprintCopy': 'Druga ključavnica, da ukradene kopije vaše denarnice ni mogoče vlomiti. PIN boste še vedno vnašali.',
  'create.turnOn': 'Vklopi',
  'create.notNow': 'Ne zdaj',

  'unlock.title': 'Odklenite Safe Wallet',
  'unlock.unlock': 'Odkleni',
  'unlock.opening': 'Odpiranje…',
  'unlock.withFingerprint': 'Odkleni s prstnim odtisom',
  'unlock.wait': 'Počakajte {seconds}s',
  'unlock.tooManyAttempts': 'Preveč poskusov. Poskusite znova čez {seconds}s.',
  'unlock.tooMany': 'Preveč napačnih PIN-ov',
  'unlock.tooManyBackup': 'Vzemite si trenutek. Spodaj lahko poskušate naprej ali obnovite dostop z varnostno prijavo ali prek zaupanja vrednega stika.',
  'unlock.tooManyLocal': 'Vzemite si trenutek in previdno poskusite znova. Ta denarnica je samo v tej napravi, zato ni varnostne kopije.',
  'unlock.forgotPin': 'Ste pozabili PIN za Safe Wallet?',
  'unlock.errFailed': 'Te denarnice ni bilo mogoče odpreti.',

  'chooser.chooseWallet': 'Izberite denarnico',
  'chooser.eachHasPin': 'Vsaka shranjena denarnica ima v tem brskalniku svoj PIN.',
  'chooser.current': 'Trenutna',
  'chooser.addAnother': 'Dodaj drug račun',

  'existing.title': 'Obstoječa denarnica',
  'existing.heading': 'Odpri mojo denarnico',
  'existing.intro': 'Za odpiranje te denarnice v tej napravi uporabite geslo računa in PIN za Safe Wallet.',
  'existing.openWallet': 'Odpri denarnico',
  'existing.forgotPin': 'Ste pozabili PIN za Safe Wallet?',
  'existing.advanced': 'Napredno: odobri z drugo napravo',
  'existing.advancedNote': 'To uporabite le za starejše preizkusne denarnice, ki še niso posodobljene za prijavo z geslom in PIN-om.',
  'existing.requesting': 'Pošiljanje zahteve…',
  'existing.requestApproval': 'Zahtevaj odobritev naprave',
  'existing.approvalTitle': 'Odobritev naprave',
  'existing.unavailable': 'Ni na voljo',
  'existing.calculating': 'Računanje…',
  'existing.mismatchNote': 'Neujemanje pomeni, da je bil ključ za seznanitev med prenosom morda spremenjen. Prekličite zahtevo in je ne odobrite.',
  'existing.cancelRequest': 'Prekliči zahtevo',
  'existing.approved': 'Naprava je odobrena',
  'existing.setPin': 'Nastavite PIN aplikacije',
  'existing.setPinNote': 'Ta PIN varuje odobreni ključ denarnice v tej napravi. Uporabite lahko isti PIN za Safe Wallet kot v drugih osebnih napravah.',
  'existing.finishing': 'Zaključevanje…',
  'existing.errPin': 'Uporabite PIN za Safe Wallet s 6 do 12 številkami.',
  'existing.errNoWallet': 'Ta račun še nima denarnice Safe Wallet. Namesto tega ustvarite novo denarnico.',
  'existing.errUpgrade': 'Potrebna je enkratna nadgradnja. To denarnico enkrat odprite v napravi, kjer že deluje, tam vklopite sinhronizacijo in nato poskusite znova.',
  'existing.errRequest': 'Odobritve naprave ni bilo mogoče zahtevati.',
  'existing.errCancel': 'Zahteve za odobritev ni bilo mogoče preklicati; samodejno bo potekla.',
  'existing.errFinish': 'Odobritve naprave ni bilo mogoče zaključiti.',
  'existing.errPairingInvalid': 'Lokalni ključ za seznanitev ni veljaven. Prekličite in začnite novo zahtevo.',
  'existing.errCancelled': 'Ta zahteva za odobritev je bila preklicana. Začnite novo zahtevo.',
  'existing.errExpired': 'Ta zahteva za odobritev je potekla. Začnite novo zahtevo.',

  'status.onDeviceOnly': 'Samo v tej napravi',
  'status.syncing': 'Sinhroniziranje…',
  'status.synced': 'Sinhronizirano',
  'status.offline': 'Brez povezave',
  'status.saving': 'Shranjevanje…',
  'status.savingLocal': 'Shranjevanje v tej napravi…',
  'status.openingDatabase': 'Odpiranje lokalne zbirke podatkov…',
  'status.couldNotStart': 'Zagon ni uspel',
  'status.errInit': 'Aplikacije Safe Wallet ni bilo mogoče zagnati.',
  'status.errDatabase': 'Lokalna zbirka podatkov ni pripravljena.',
  'menu.closeMenu': 'Zapri meni',
  'action.showAll': 'Prikaži vse',

  'conflict.collection': 'Zbirka',
  'conflict.deletedVersion': 'Izbrisana različica je v neskladju z drugo spremembo',
  'conflict.multipleChanges': 'Več sprememb brez povezave',
  'conflict.title': 'Neskladje',
  'conflict.chooseVersion': 'Izberite različico, ki jo želite obdržati',
  'conflict.note': 'Obe šifrirani različici sta ohranjeni, dokler ne izberete. Izbrisano različico lahko izberete namenoma.',
  'conflict.loading': 'Nalaganje različic…',
  'conflict.deleted': 'Izbrisana različica',
  'conflict.resolving': 'Razreševanje…',
  'conflict.keepDeleted': 'Obdrži izbrisano',
  'conflict.useThis': 'Uporabi to različico',
  'conflict.errOpen': 'Neskladnih različic ni bilo mogoče odpreti.',
  'conflict.errResolve': 'Tega neskladja ni bilo mogoče razrešiti.',
  'conflict.screenNote': 'Spremembe, narejene brez povezave v več napravah, ostanejo šifrirane in se ohranijo, dokler ne izberete, katero različico obdržite.',
  'conflict.none': 'Ni neskladij.',

  'collections.newName': 'Ime nove zbirke',
  'collections.note': 'Zbirke so zasebne mape. Vnos lahko pripada več zbirkam.',
  'collections.confirmDelete': 'Želite izbrisati zbirko »{name}«? Vnosi ostanejo v aplikaciji Safe Wallet.',

  'item.confirmDelete': 'Želite izbrisati »{title}«? Vnos je mogoče omejen čas obnoviti iz zgodovine varnostnih kopij.',
  'reminder.confirmDone': 'Želite označiti ta opomnik kot opravljen?\n\nDatum opomnika ostane pri vnosu.',
  'reset.confirmOther': 'Želite odstraniti »{name}« iz tega brskalnika? Šifrirana varnostna kopija v računu ne bo izbrisana, druge denarnice v tem brskalniku pa ostanejo nedotaknjene. Za ponovno dodajanje boste potrebovali varnostni račun in PIN.',
  'reset.confirmLast': 'Želite odstraniti to lokalno denarnico iz tega brskalnika? Šifrirani podatki, ki so že sinhronizirani, ne bodo izbrisani iz računa. Spremembe, ki še čakajo na pošiljanje, in odobritev te naprave bodo izbrisane.',

  'merge.confirmAdd': 'Ta račun že ima denarnico. Ali želite vanjo dodati svoje {items}, vključno s fotografijami in datotekami, ter preklopiti nanjo?\n\nVaša trenutna denarnica ostane v tem brskalniku, dokler je ne odstranite.',
  'merge.notice': 'V to denarnico je dodano: {items}, skupaj s pripadajočimi fotografijami in datotekami. Vaša stara denarnica »{name}« je še vedno v tem brskalniku. Ko bo njena varnostna kopija poslana, jo lahko spodaj odstranite.',
  'merge.removeOld': 'Odstrani staro denarnico',
  'merge.backingUp': 'Izdelava varnostne kopije…',
  'merge.dismiss': 'Zapri',
  'merge.confirmRemoveOld': 'Želite odstraniti staro denarnico »{name}« iz tega brskalnika?\n\nNjeni vnosi so že prekopirani v to denarnico in shranjeni v vašem računu. S tem se izbriše samo stara lokalna kopija v tem brskalniku.',
  'merge.errMismatch': 'Odprta denarnica se ne ujema z računom, izbranim za kopiranje. Iz izvirne denarnice ni bilo nič odstranjeno.',
  'merge.errOpenLocal': 'Odprite lokalno denarnico, preden njene vnose dodate v drugo denarnico.',
  'merge.errNoWallet': 'Ta račun nima denarnice, v katero bi dodali vnose.',
  'merge.errKeyPackage': 'Enkrat odprite denarnico tega računa v napravi, kjer že deluje, nato poskusite znova.',
  'merge.errPin': 'Ta PIN ne odpre denarnice, ki je že v tem računu. Vnesite PIN tiste denarnice.',

  'pin.errNoSync': 'Sinhronizacija ni nastavljena, zato PIN-a ni mogoče posodobiti za nove naprave.',
  'pin.errNoEmail': 'Za to denarnico v tej napravi ni shranjenega e-poštnega naslova računa.',
  'pin.errOffline': 'Videti je, da niste povezani. Znova se povežite, da spremenite PIN za prijavo v novih napravah.',
  'pin.errWrongPassword': 'To geslo računa ni pravilno.',
  'pin.errDeviceUnavailable': 'Ta naprava ni na voljo.',
  'pin.changedBoth': 'PIN je spremenjen v tej napravi in za prijavo v novih napravah.',
  'pin.changedLocal': 'PIN aplikacije je spremenjen. Novi PIN uporabite, ko se ta naprava naslednjič zaklene.',

  'recover.accountTitle': 'Račun Safe Wallet',
  'recover.passwordChanged': 'Geslo je spremenjeno',
  'recover.passwordChangedNote': 'Znova se prijavite z novim geslom računa. Vaš PIN aplikacije in vaša šifrirana denarnica nista bila spremenjena.',
  'recover.continue': 'Naprej',
  'recover.choosePassword': 'Izberite novo geslo',
  'recover.choosePasswordNote': 'To spremeni samo geslo računa za sinhronizacijo. Vaš PIN aplikacije ostane nespremenjen, samo s tem geslom pa vaše šifrirane denarnice ni mogoče odpreti v novi napravi.',
  'recover.checkingLink': 'Preverjanje povezave za obnovitev…',
  'recover.newPassword': 'Novo geslo računa',
  'recover.repeatPassword': 'Ponovite novo geslo',
  'recover.updating': 'Posodabljanje…',
  'recover.updatePassword': 'Posodobi geslo',
  'recover.errShort': 'Uporabite vsaj 8 znakov.',
  'recover.errMismatch': 'Vnosa gesla se ne ujemata.',
  'recover.errUpdate': 'Gesla računa ni bilo mogoče posodobiti.',

  'recover.walletTitle': 'Obnovitev denarnice',
  'recover.freshVerification': 'Za obnovitev denarnice je vedno potrebno novo preverjanje vašega računa. Safe Wallet nikoli ne vpraša zaupanja vrednega stika za vašo kodo.',
  'recover.useOnlyWhen': 'To uporabite le, kadar nobena vaša naprava ne more ponastaviti PIN-a. Potrebujete novo preverjanje po e-pošti in odobritev enega zaupanja vrednega stika Safe Wallet.',
  'recover.accountEmail': 'E-poštni naslov računa',
  'recover.emailCode': 'Potrditvena koda iz e-pošte',
  'recover.sendAnother': 'Pošlji novo kodo',
  'recover.authenticator': 'Aplikacija za overjanje',
  'recover.authenticatorCode': 'Koda iz aplikacije za overjanje',
  'recover.verifyStart': 'Preveri e-pošto in začni',
  'recover.verifyContinue': 'Preveri e-pošto in nadaljuj',
  'recover.deviceFingerprint': 'Prstni odtis naprave, ki obnavlja',
  'recover.readFingerprint': 'Ta prstni odtis preberite svojemu zaupanja vrednemu stiku med živim pogovorom. Poklicati vas mora na kontaktne podatke, ki jih je že imel — nikoli na številko, ki mu je bila za to poslana.',
  'recover.status': 'Stanje:',
  'recover.waitingEnds': 'Čakalna doba se konča:',
  'recover.expires': 'Poteče:',
  'recover.cancel': 'Prekliči obnovitev',
  'recover.setNewPin': 'Nastavite nov PIN aplikacije',
  'recover.keyRebuilt': 'Ključ vaše denarnice je bil obnovljen samo v tem brskalniku. Zaščita za obnovitev je zdaj porabljena in jo je treba znova nastaviti.',
  'recover.deviceName': 'Ime naprave',
  'recover.newPin': 'Nov PIN aplikacije',
  'recover.repeatPin': 'Ponovite PIN',

  'invite.securityConfirmation': 'Varnostna potrditev',
  'invite.title': 'Povabilo za obnovitev',
  'invite.helpSomeone': 'Pomagajte nekomu, ki mu zaupate',
  'invite.invitedBy': 'Povabil',
  'invite.askedYou': 'Ta oseba vas je prosila, da ste njen zaupanja vreden stik za obnovitev.',

  'invite.cannotSee': 'Njene denarnice ne morete videti.',
  'invite.cannotSeeNote': 'Kar je shranjeno v njej, ostane šifrirano in zasebno.',
  'invite.cannotRecover': 'Sami je ne morete obnoviti.',
  'invite.cannotRecoverNote': 'Pomagate šele potem, ko lastnik sam začne obnovitev.',
  'invite.nothingToRemember': 'Vam si ni treba ničesar zapomniti.',
  'invite.nothingToRememberNote': 'Safe Wallet vse varno pripravi, takoj ko sprejmete.',
  'invite.enterPin': 'Vnesite svoj PIN',
  'invite.confirming': 'Potrjevanje…',
  'invite.decline': 'Zavrni',
  'invite.accept': 'Sprejmi povabilo',
  'invite.confirmWithPin': 'Potrdite s svojim PIN-om',
  'invite.acceptTitle': 'Sprejmi povabilo za obnovitev',
  'invite.confirmBecome': 'Potrdite, da želite postati stik za obnovitev za:',
  'invite.declineTitle': 'Zavrni povabilo',
  'invite.declineQuestion': 'Ne želite postati stik za obnovitev?',
  'invite.invitationFrom': 'Povabilo od',
  'invite.keep': 'Obdrži povabilo',
  'invite.accepted': 'Povabilo je sprejeto',
  'invite.nowContact': 'Zdaj ste stik za obnovitev',
  'invite.nothingUnless': 'Ničesar vam ni treba storiti, razen če',
  'invite.inboxTitle': 'Povabila za obnovitev',
  'invite.review': 'Preglej povabilo',
  'invite.errConfirm': 'Tega ni bilo mogoče potrditi.',
  'invite.errAccept': 'Tega povabila ni bilo mogoče sprejeti.',
  'invite.errDecline': 'Tega povabila ni bilo mogoče zavrniti.',

  'protect.preparing': 'Pripravljanje zaščite za obnovitev…',
  'protect.addPerson': 'Dodajte zaupanja vredno osebo',
  'protect.addPersonNote': 'Zaupanja vredna oseba vam lahko pomaga znova priti v denarnico. Vaše denarnice ne more videti in je brez vas ne more obnoviti.',
  'protect.addSoYouCan': 'Dodajte zaupanja vredno osebo, da boste lahko znova prišli noter, če izgubite PIN ali napravo.',
  'protect.mustHaveAccount': 'Ta oseba mora že imeti račun Safe Wallet.',
  'protect.useTheirEmail': 'Uporabite e-poštni naslov, povezan z njenim računom Safe Wallet.',
  'protect.emailLabel': 'E-pošta Safe Wallet zaupanja vredne osebe',
  'protect.emailPlaceholder': 'ime@primer.si',
  'protect.send': 'Pošlji povabilo',
  'protect.yourPeople': 'Vaše zaupanja vredne osebe',
  'protect.onlyYouSee': 'Ta seznam vidite samo vi.',
  'protect.waiting': 'Čakanje na sprejem',
  'protect.pending': 'V čakanju',
  'protect.canHelp': 'Lahko pomaga, ko zahtevate obnovitev',
  'protect.active': 'Aktivno',
  'protect.protectionActive': 'Zaščita za obnovitev je vklopljena',
  'protect.becomesActive': 'Zaščita za obnovitev začne delovati, ko ena povabljena oseba sprejme.',
  'protect.errLoad': 'Zaščite za obnovitev ni bilo mogoče naložiti.',
  'protect.errSelf': 'Izberite drugega uporabnika Safe Wallet.',
  'protect.errNoAccount': 'Za ta e-poštni naslov ni bilo najdenega računa Safe Wallet. Prosite to osebo, da najprej ustvari in potrdi svoj račun.',
  'protect.errNotReady': 'Ta račun Safe Wallet še ni pripravljen za povabila za obnovitev. Prosite to osebo, da enkrat odpre in odklene svoj posodobljeni Safe Wallet, nato poskusite znova.',
  'protect.errCheck': 'Tega računa Safe Wallet ni bilo mogoče preveriti.',
  'protect.errSend': 'Tega povabila ni bilo mogoče poslati.',
  'invite.willBeRemoved': 'bo odstranjeno. Pozneje vas lahko znova povabi.',
  'invite.asksForHelp': 'prosi za pomoč pri vrnitvi v svojo denarnico.',
  'protect.notSetUp': 'Ni nastavljeno',
  'protect.checking': 'Preverjanje…',
  'reminder.done': 'Opravljeno',
  'reminder.doneOn': 'Opravljeno {date}',
  'invite.enterWalletPin': 'Vnesite svoj PIN za Safe Wallet',
  'invite.confirmInviteNote': 'Potrdite, da želite to osebo povabiti kot stik za obnovitev.',
  'invite.confirmInvite': 'Potrdi povabilo',
  'recover.startTitle': 'Začni obnovitev',
  'recover.continueTitle': 'Nadaljuj obnovitev',
  'invite.invitedYouTo': 'vas je povabil, da ste njegov zaupanja vreden stik za obnovitev.',
  'approve.inboxTitle': 'Nekdo potrebuje vašo pomoč',
  'approve.isRecovering': 'poskuša znova priti v svojo denarnico.',
  'approve.review': 'Preglej zahtevo',
  'approve.title': 'Ali dovolite vrnitev v denarnico?',
  'approve.fingerprintLabel': 'Koda, prikazana na njegovi novi napravi',
  'approve.callFirst': 'Najprej ga pokličite — na številko, ki ste jo že imeli, nikoli na tisto, ki so vam jo poslali. Naj vam prebere kodo s svojega zaslona in preverite, ali se natanko ujema s to.',
  'approve.onlyIfSure': 'Odobrite le, če se koda ujema in ste prepričani, da je res on. Če ni, mu takoj povejte, da lahko zahtevo prekliče.',
  'approve.approve': 'Kodi se ujemata — odobri',
  'approve.approving': 'Odobravanje…',
  'approve.notNow': 'Ne zdaj',
  'approve.done': 'Odobreno. Zdaj lahko spet vstopi.',
  'approve.errApprove': 'Te zahteve ni bilo mogoče odobriti.',
  'approve.waitUntil': 'Nadaljuje lahko od {time}.',
};

// Slovenian uses four forms: one (1), two (2), few (3–4) and other.
export const plurals: Plurals = {
  items: { one: '{count} vnos', two: '{count} vnosa', few: '{count} vnosi', other: '{count} vnosov' },
  minutes: { one: '{count} minuta', two: '{count} minuti', few: '{count} minute', other: '{count} minut' },
  queued: { one: '{count} sprememba na čakanju', two: '{count} spremembi na čakanju', few: '{count} spremembe na čakanju', other: '{count} sprememb na čakanju' },
  helpers: { one: '{count} zaupanja vredna oseba je pripravljena pomagati.', two: '{count} zaupanja vredni osebi sta pripravljeni pomagati.', few: '{count} zaupanja vredne osebe so pripravljene pomagati.', other: '{count} zaupanja vrednih oseb je pripravljenih pomagati.' },
};
